import { FilterKey } from '@studyportals/search-filters';
export class ContinentIsEuropeRule {
    EUROPE_ID = 1;
    forSearch(dependencies) {
        const { filterState, seoInfoBase } = dependencies;
        const selectedContinent = seoInfoBase.getFilterOptionValueBy(FilterKey.CONTINENT, filterState);
        return Promise.resolve(selectedContinent === this.EUROPE_ID.toString());
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    forSitemapGenerator(filterKeyValues) {
        throw new Error('Method not implemented.');
    }
    getName() {
        return 'ContinentIsEuropeRule';
    }
}
